import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  contactsHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: '8px 25px',
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_400.main
        : theme.palette.white_100.main,
    borderBottom:
      theme.palette.type === 'dark'
        ? '1px solid' + theme.palette.dark_stroke.main
        : '1px solid' + theme.palette.gray_stroke.main,
    // backgroundImage:
    //   theme.mode === 'light'
    //     ? `url(${whatsBackground})`
    //     : `url(${whatsBackgroundDark})`,
    // backgroundPosition: 'center',
    // backgroundSize: 'cover',
    // backgroundRepeat: 'no-repeat',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: 8
    }
  },
  headerTitleBox: {
    width: '100%',
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
    '& h5': {
      fontWeight: '600',
      fontSize: '1.25rem',
      color: theme.palette.blue_300.main
    },
    '& .MuiTypography-gutterBottom': {
      marginBottom: 0
    }
  },
  headerTutorial: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    '& span': {
      fontWeight: '600',
      fontSize: '1rem'
    },
    '& button': {
      color: theme.palette.blue_100.main,
      '& span': {
        display: 'flex',
        gap: '4px'
      }
    },
    '& button:hover': {
      color: theme.palette.blue_300.main,
      backgroundColor: 'transparent'
    }
  },
  headerDescription: {
    '& span': {
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_400.main
    }
  }
}))
